export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9392.05b5f6d5.jpg";